<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar title="收款管理" left-arrow @click-left="$router.go(-1)" />
    </van-sticky>
    <van-tabs
      v-model="active"
      title-active-color="#3B6BFB"
      title-inactive-color="#999"
      color="#3B6BFB"
      @click="getType"
    >
      <van-tab title="支付宝">
        <van-cell-group>
          <van-field v-model="gatherInfo.ali_number" label="支付宝账号" placeholder="请输入支付宝账号" />
          <van-cell title="支付宝收款码">
            <div slot="default">
              <van-uploader :after-read="upAli">
                <img :src="gatherInfo.ali_image" alt v-if="gatherInfo.ali_image!=''" class="aliImg" />
                <img src="../../assets/imgs/personal/upImg.png" alt class="aliImg" v-else />
              </van-uploader>
            </div>
          </van-cell>
        </van-cell-group>
      </van-tab>
      <van-tab title="微信">
        <van-cell-group>
          <van-field v-model="gatherInfo.wx_number" label="微信账号" placeholder="请输入微信账号" />
          <van-cell title="微信收款码">
            <div slot="default">
              <van-uploader :after-read="upWx">
                <img :src="gatherInfo.wx_image" alt v-if="gatherInfo.wx_image!=''" class="aliImg" />
                <img src="../../assets/imgs/personal/upImg.png" alt class="aliImg" v-else />
              </van-uploader>
            </div>
          </van-cell>
        </van-cell-group>
      </van-tab>
      <van-tab title="银行卡">
        <van-cell-group >
          <van-field v-model="gatherInfo.bank_name" label="开户银行" placeholder="请输入开户银行" label-width='150'/>
          <van-field v-model="gatherInfo.bank_branch" label="开户支行" placeholder="请输入开户支行" label-width='150'/>
          <van-field v-model="gatherInfo.bank_owner" label="开户人姓名" placeholder="请输入开户人姓名" label-width='150'/>
          <van-field v-model="gatherInfo.bank_phone" label="银行预留手机号" placeholder="请输入银行预留手机号" label-width='150'/>
          <van-field v-model="gatherInfo.bank_number" label="银行卡账号" placeholder="请输入银行卡账号" label-width='150'/>
        </van-cell-group>
      </van-tab>
    </van-tabs>
    <van-button class="submitBtn" @click="submitGather">提交</van-button>
  </div>
</template>
<script>
import { userInfo, updatePayInfo, fileUpload } from "@/api/personal";
export default {
  data() {
    return {
      active: 0,
      gatherInfo: {
        type: 1
      }
    };
  },
  created() {
    userInfo().then(res => {
      this.gatherInfo = res;
      this.gatherInfo.type = 1;
    });
  },
  methods: {
    getType(e) {
      this.gatherInfo.type = Number(e) + 1;
    },
    upAli(file) {
      let formData = new FormData();
      formData.append("image", file.file);
      fileUpload(formData).then(res => {
        this.gatherInfo.ali_image = res.path;
      });
    },
    upWx(file) {
      let formData = new FormData();
      formData.append("image", file.file);
      fileUpload(formData).then(res => {
        this.gatherInfo.wx_image = res.path;
      });
    },
    submitGather() {
      updatePayInfo(this.gatherInfo).then(res => {
        this.$toast("提交成功!");
        setTimeout(() => {
          this.$router.go(-1);
        }, 200);
      });
    }
  }
};
</script>
<style lang='less' scoped>
.wrap {
  height: 100vh;
  position: relative;
  /deep/ .van-tabs__line {
    background-color: #fe881e;
    height: 0.05rem;
    bottom: 0.5rem;
  }
  .submitBtn {
    position: fixed;
    width: 100%;
    height: 40px;
    color: #fff;
    font-size: 16px;
    background: #fe881e;
    left: 0;
    bottom: 0;
    line-height: 40px;
  }
  .aliImg {
    width: 120px;
    height: 120px;
  }
}
</style>
